import Vue from 'vue'
import Scrollactive from 'vue-scrollactive'

Vue.use(Scrollactive)
const el = document.querySelector('#faq-links')
if (el != null) {
  // eslint-disable-next-line no-unused-vars
  const app = new Vue({
    el: '#faq-links',
    data: {
      elements: []
    },
    mounted () {
      this.elements = this.$el.querySelectorAll('.scrollactive-item')
    }
  })
}
